module.exports = __webpack_public_path__ + "static/media/illustration-element-03.8c18c58d.svg";